export default "__VITE_ASSET__f52fd65c__"